// import React from 'react';
// import loadable from '@loadable/component';

// const PromotionListWithFilters = (props) => {
//   const Component = loadable(() => import('./PromotionListWithFilters.js'), { ssr: false });
//   return <Component {...props} />;
// };

// export default PromotionListWithFilters;

import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import './style.scss';
import '../PromotionListComponent/style.scss';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';
import SearchComponent from './Search';
import FilterComponent from './Filter';
import { withTranslation } from 'react-i18next';
import PaginationComponent from './Pagination';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import ResultsNotFound from './ResultsNotFound';
import helpers from './helpers/index.js';
import Button from '../Shared/components/controls/Button';
import useWindowSize from '../Shared/hooks/useWindowSize';
import { useHistory } from 'react-router-dom';
import { loader as gqlLoader } from 'graphql.macro';
import Item from '../PromotionListComponent/Item';
import { PromotionContext } from './context';
import { useQuery } from 'react-apollo';

const query = gqlLoader('./API/Listing.graphql'); //query code
/***Component***/
const PromotionListWithFilters = (props) => {
  const [width] = useWindowSize();
  const history = useHistory();
  const setPageQueryString = (page, item) => {
    history.push({ search: `page=${page}&item=${item}` });
  };

  var isMobile = false;
  if (width > 768) {
    isMobile = false;
  } else {
    isMobile = true;
  }
  //language
  const { t, i18n, params } = props;
  const {
    endDate,
    //no result page
  } = props?.fields;
  const language = i18n.language;
  //constants
  const pageSizes = props?.fields?.pageSizes;

  const context = useSitecoreContext();
  const { imageAlignment } = props.params;

  const offerCategoryName = props?.fields?.title?.value; //change to the search term

  const defaultPageSize = props?.fields?.defaultPageSize; //default page size { value: 2 }; //

  const [numberOfFilters, setNumberOfFilters] = useState(0);
  const [dataRetrieved, setDataRetrieved] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    itemsPerPage: defaultPageSize.value,
    pagesTotalNumber: 1,
    hasNext: false,
    hasPrevious: false,
    itemsCount: 0,
  });
  const [mobileFiltersIsToggle, setMobileFiltersIsToggle] = useState(false);

  var year = new Date().getFullYear();
  var month = new Date().getMonth();
  let firstOfThisMonthDate = new Date(year, month, 1);

  // All filters
  const [allFilters, setAllFilters] = useState({
    //filtering
    categoryFilter: [],
    tagFilter: [],
    validityFilter: { from: firstOfThisMonthDate, to: endDate }, //date format:2021-12-31T16:00:00Z
    selectedCategoriesIDForGraphGql: [],
    keyword: '',
    validityFilterStartDate: firstOfThisMonthDate,
    validityFilterEndDate: endDate,
    reRender: true,
    filtersCount: 0,
  });

  //END: date range
  //index name for the query
  let indexName = 'FAB2_#datebase#_index'.replace(
    '#datebase#',
    context?.sitecoreContext?.route?.databaseName
  );
  //related to building the variable when filtering
  const [filterVariable, setFilterVariable] = useState({
    index: indexName,
    first: defaultPageSize.value,
    after: '0',
    fieldsEqual: [{ name: '_templatename', value: 'Promotion Detail' }],
  });

  const { data } = useQuery(query, {
    variables: filterVariable,
    onCompleted: () => {
      setDataRetrieved(true);
    },
  });
  var search = typeof window !== 'undefined' ? window?.location?.search?.split('?page=')[1] : '';
  var currentPage = !!search?.split('&')[0] ? search?.split('&')[0] : 1;
  var itemsPerPage = !!search?.split('&')[1]?.split('item=')[1]
    ? search?.split('&')[1]?.split('item=')[1]
    : defaultPageSize.value;
  var items = data?.search?.results?.items;
  const totalItemsCount = data?.search?.results?.totalCount;
  var hasNext = false;
  var hasPrevious = false;
  var pagesTotalNumberVar = -1;

  useEffect(() => {
    //get pagination from query string

    if (Array.isArray(items) && items?.length > 0) {
      pagesTotalNumberVar =
        totalItemsCount / itemsPerPage < 1 ? 1 : Math.ceil(totalItemsCount / itemsPerPage);

      if (pagesTotalNumberVar > currentPage) {
        hasNext = true;
      }
      if (currentPage > 1) {
        hasPrevious = true;
      }
    }

    setPagination((prev) => {
      return {
        ...prev,
        currentPage: currentPage,
        itemsCount: totalItemsCount,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        itemsPerPage: itemsPerPage,
        pagesTotalNumber: pagesTotalNumberVar === -1 ? 1 : pagesTotalNumberVar,
      };
    });
  }, [data]);

  useEffect(() => {
    helpers({
      allFilters,
      firstOfThisMonthDate,
      setFilterVariable,
      indexName,
      language,
      pagination,
      isMobile,
      setNumberOfFilters,
    });
  }, []);

  useEffect(() => {
    const { keyword } = { ...allFilters };

    helpers({
      allFilters,
      firstOfThisMonthDate,
      setFilterVariable,
      indexName,
      language,
      pagination,
      keyword,
      isMobile,
      setNumberOfFilters,
    });
  }, [
    allFilters,
    pagination?.itemsPerPage,
    pagination?.currentPage,
    allFilters?.reRender,
    numberOfFilters,
  ]);

  //reset the filters and tags on click of the button in the not found results
  const handleResetFiltersCallback = () => {
    setAllFilters((prev) => {
      return {
        ...prev,
        categoryFilter: [],
        tagFilter: [],
        validityFilter: {
          from: firstOfThisMonthDate.toISOString(),
          to: endDate,
        },
        //date format:2021-12-31T16:00:00Z
        selectedCategoriesIDForGraphGql: [],
        validityFilterEndDate: endDate,
        filtersCount: prev.filtersCount - 1,
      };
    });
  };

  //on change of the dropdown of items per page
  const handleSelectedItemsPerPageChange = (event) => {
    let itemsPerPageDropdownValue = parseInt(event.target.value);

    pagesTotalNumberVar =
      totalItemsCount / itemsPerPageDropdownValue < 1
        ? 1
        : Math.ceil(totalItemsCount / itemsPerPageDropdownValue);
    if (pagesTotalNumberVar > pagination?.currentPage) {
      hasNext = true;
    }
    if (pagination?.currentPage > 1) {
      hasPrevious = true;
    }

    setPagination((prev) => {
      return {
        ...prev,
        currentPage: 1,
        itemsCount: totalItemsCount,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        itemsPerPage: itemsPerPageDropdownValue,
        pagesTotalNumber: pagesTotalNumberVar,
        itemsCount: totalItemsCount,
      };
    });
    setPageQueryString(1, itemsPerPageDropdownValue);
  };
  function handleClick() {
    history.goBack();
  }

  const providerValue = {
    allFilters,
  };
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="PromotionListWithFilters" />;
  }
  return (
    <PromotionContext.Provider value={providerValue}>
      <div className={clsx('OfferCategoryListingSection', 'add-margins', params?.Styles)}>
        <div className="content">
          <Button
            className="back"
            onClick={handleClick}
            color="primary"
            variant="text"
            arrow="left"
            fullWidth={false}
          >
            {t('Back')}
          </Button>

          <SearchComponent
            {...{
              props,
              allFilters,
              firstOfThisMonthDate,
              offerCategoryName,
              indexName,
              language,
              setAllFilters,
              pagination,
              t,
              count: totalItemsCount,
              mobileFiltersIsToggle,
              setMobileFiltersIsToggle,
              isMobile,
              numberOfFilters,
              setNumberOfFilters,
            }}
          />
          <FilterComponent
            {...{
              props,
              t,
              setAllFilters,
              allFilters,
              mobileFiltersIsToggle,
              setMobileFiltersIsToggle,
              setNumberOfFilters,
              firstOfThisMonthDate,
              offerCategoryName,
              indexName,
              language,
              setFilterVariable,
              isMobile,
            }}
          />
          <div
            className={clsx(
              'PromotionListComponent',
              imageAlignment?.toLowerCase().replace(/\s/g, '-')
            )}
          >
            {dataRetrieved && Array.isArray(items) && items?.length > 0 && (
              <div className={clsx('contentInner')}>
                <div className="items">
                  {items?.map((card, iCard) => {
                    return <Item item={{ fields: { ...card?.item } }} key={iCard} props={props} />;
                  })}
                </div>
              </div>
            )}

            {dataRetrieved && items?.length <= 0 && (
              <ResultsNotFound
                props={props}
                name={offerCategoryName}
                reset={handleResetFiltersCallback}
              />
            )}
          </div>
          {totalItemsCount > 0 && (
            <PaginationComponent
              onChange={handleSelectedItemsPerPageChange}
              pagination={pagination}
              allFilters={allFilters}
              pageSizes={pageSizes}
              setPagination={setPagination}
              t={t}
            />
          )}
        </div>
      </div>
    </PromotionContext.Provider>
  );
};

export default withTranslation()(PromotionListWithFilters);

